import { WSAlert } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { queriesExternalBankAccounts } from "@query";
import { selectorExternalBankAccountCountry } from "@selectors/selectorExternalBankAccountCountry";
import { PATH_SETTINGS_ACCOUNT_INFO } from "../paths";
import { useDefaultPayoutMethod } from "./payout/DefaultPayoutMethod";

export const usePayoutMethodMissingData = () => {
  const defaultPayoutMethod = useDefaultPayoutMethod();
  const queryExternalBankAccount =
    queriesExternalBankAccounts.getExternalBankAccount.useQuery(
      { bankAccountId: defaultPayoutMethod?.id ?? "" },
      {
        enabled:
          defaultPayoutMethod?.type === "Account" && !!defaultPayoutMethod?.id
      }
    );

  const country = queryExternalBankAccount.data
    ? selectorExternalBankAccountCountry(queryExternalBankAccount.data)
    : undefined;

  const queryMissingFields =
    queriesExternalBankAccounts.getExternalBankAccountMissingFields.useQuery(
      { bankAccountId: defaultPayoutMethod?.id ?? "" },
      {
        enabled: !!country && country !== "US"
      }
    );

  return queryMissingFields.data;
};

export const AlertPayoutMethodMissingData: React.FC = () => {
  const history = useHistory();
  const payoutMethodMissingData = usePayoutMethodMissingData();

  if (
    (payoutMethodMissingData?.requiredFields || []).length === 0 &&
    (payoutMethodMissingData?.requiredDocuments || []).length === 0
  ) {
    return null;
  }

  return (
    <WSAlert
      theme="warning"
      icon="alert"
      title="Missing information required"
      action={{
        text: "Go to account settings",
        onClick: () => {
          history.push(PATH_SETTINGS_ACCOUNT_INFO);
        }
      }}
    >
      Additional information is required to complete your profile. Go to your
      account settings and provide the missing information to prevent payout
      delays.
    </WSAlert>
  );
};
